<script setup>
import { useModalsStore, useGlobalStore, renderDialogContent, useRuleCheckStore } from 'shared' // 这里用shared，@/store内有初始化代码会报错
// import { useGlobalStoreFormat } from '@/store'

import { useNioOsSDK } from '@/hooks'
import NioMessageBox from '@ui/NioMessageBox'
import { RuleButtonType } from 'config-request/src/interfaces/rule-check'
import { isTpad,disAppearTrace } from '@common/utils'
import OptionBundlePopup from 'bizComponents/OptionBundlePopup/wrapper.vue'


// 导航栏样式

const route = useRoute()
const { showMode, featureTypeToStep,  updateCurrentStep, showAllPage, isOptionalOriginal } = toRefs(useGlobalStore())
const ruleCheckStore = useRuleCheckStore()
// const { isOptional } = toRefs(useGlobalStoreFormat())

// 初始化header内容
onMounted(async () => {
  if(isTpad){
    disAppearTrace()
    return
  }
  await useNioOsSDK()
  // nioSDK.renderHeader(document.getElementById('nio-config-header'))

  


})

// 全局响应数据冲突确认弹窗
const modalsStore = useModalsStore()
const handleJump = (buttonParam) => {
  if (!buttonParam) return
  try {
    const param = JSON.parse(buttonParam)
    // 配置页场景执行步骤切换，showAll场景通过actionData在各业务组件内部处理跳转
    if (!showAllPage.value) {
      const indexSteps = featureTypeToStep.value(param?.feature_type ?? '')
      indexSteps && updateCurrentStep.value(indexSteps)
    }
  } catch (error) {
    console.log('relationModal jump parse error', error)
  }
}
const handleButtonAction = (buttonConfig) => {
  if (!buttonConfig || typeof buttonConfig !== 'object') {
    modalsStore.relationModalConfirm()
    return
  }
  switch (buttonConfig.type) {
    case RuleButtonType.Cancel:
    case RuleButtonType.Keep:
      modalsStore.relationModalCancel()
      break
    case RuleButtonType.Jump:
      handleJump(buttonConfig.param)
      modalsStore.relationModalCancel(buttonConfig)
      break
    default:
      if (buttonConfig.param) {
        handleJump(buttonConfig.param)
        // 跳转并执行配置切换后，重置首次访问标记
        ruleCheckStore.setIsFirstEntry(!showAllPage.value)
        modalsStore.relationModalConfirm(buttonConfig)
      } else {
        modalsStore.relationModalConfirm()
      }
      break
  }
}
watch(modalsStore.relationModal, (relationModal) => {
  let visible = relationModal.visible;
  let content = renderDialogContent(relationModal.content);
  content = itemToHtml(content);


  if (!visible) return
  NioMessageBox.confirm(content, relationModal.title ?? '配置更改确认', { buttonList: relationModal.buttonList })
    .then((data) => {
      handleButtonAction(data)
    })
    .catch(() => {
      modalsStore.relationModalCancel();
    })
})
const itemToHtml = (list) => {
  let html = '';
  list.forEach(el => {
    let item = el.isBold ? `<span style="font-weight: bold;">${el.content}</span>` : `<span>${el.content}</span>`
    html = `${html}${item}`
  });
  return html
}

const showModelCustom = computed(()=>{
  if(isOptionalOriginal.value){
    return '2D'
  }else{
    return showMode.value
  }
  // if(showMode.value == '2D') return showMode.value
  // hasOptional
})

const classMap = computed(() => ({
  ['page-' + route.name]: true,
  ['nio-' + showModelCustom.value]: true,
  ['pad-content']:isTpad,
}))

</script>

<template>
  <div id="nio-config" class="nio-full" :class="isTpad ? 'nio-config-wrap-pad' : ''">
    <div id="nio-config-header" v-if="!isTpad"></div>
    <div id="nio-config-content" :class="classMap">
      <keep-alive>
        <router-view v-if="route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!route.meta.keepAlive"></router-view>
      <option-bundle-popup />
    </div>
  </div>
</template>

<style lang="scss" scoped>

.nio-config-wrap-pad{
  padding-top: 24px;
  box-sizing: border-box;
}
#nio-config-header {
  height: $nio-header-height;
  background-color: #f5f5f5;
}

#nio-config-content {
  position: relative;
  height: calc(100% - $nio-header-height);
  background: $background-gradient;
  // overflow-x: hidden;
}
.pad-content{
  height:100% !important;
}
</style>
